import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const SocialManagerModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white, red300] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
    'red.300',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)
  const fillRedBG = useColorModeValue(red300, red300)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Gestor_Social" data-name="Gestor Social">
          <path
            fill={fillColor200}
            opacity="0.25"
            d="M322.53,288C213.52,370.11-39,451.24,75.41,672.08c89.35,166.79,234.1,72.59,378.73,59.13C1068.17,673.91,666.33,62.8,322.53,288Z"
          />
          <g id="group400">
            <path
              fill={fillColor400}
              opacity="0.2"
              d="M636.94,599.9a84.53,84.53,0,0,1-14.53,40.15c-26.69,39.31-75.65,116.75-119.85,126-71.24,14.9-63.5-96.85-83.52-150C363.88,469.56,646.48,483.62,636.94,599.9Z"
            />
            <path
              fill={fillColor400}
              opacity="0.2"
              d="M362.63,150.79A69,69,0,0,1,348.56,183c-23.92,31-68.45,92.2-105.12,97.46-59.42,8.53-47.19-83-60.91-127.77C144.64,29.27,376.44,55.56,362.63,150.79Z"
            />
          </g>
          <path
            fill={fillColor600}
            d="M687.64,398.32a35.59,35.59,0,0,0-41.46-10.66c-15.12,6.29-34.38,14-36.42,17.91-9.62,18.1,73.16,41.34,86.65,37.31C711.7,438.14,701.19,415.39,687.64,398.32Z"
          />
          <path
            fill={fillColor600}
            d="M115.56,691.17c.12,18.68,31.93,34.5,41.32,22.81,9.28-13.84-14.59-34.84-28.46-47.7C120.25,663.93,115.77,677.73,115.56,691.17Z"
          />
          <path
            fill={fillColor600}
            d="M262.73,118.05c-18.35,7.38-42.65-10.25-49.92-28.48s5-30.38,23.24-37.76,55.87-5.25,63.14,13C306.69,83.14,281.08,110.66,262.73,118.05Z"
          />
          <path
            fill={fillColor600}
            d="M182,92.3c-.77.21-1.37.43-2.14.64C172.6,94.83,59.79,160.08,39.55,327.81a377.11,377.11,0,0,0,1.1,95.94C65.24,604.37,147.76,670.21,206.16,719.61c13.89,11.78,32.43,21.87,53.66,30,101.83,39.12,216.88,11.77,292.59-66.77,87.64-90.93,150.93-72.69,144.32-158.58-7.67-99.58-92.32-70.4-230.19-102-62.15-14.22-118.18-48.35-158.18-98C217.15,211.12,227.48,78.86,182,92.3Z"
          />
          <polygon
            stroke={strokeColor900}
            strokeWidth={strokenWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={fillBG}
            points="207 608.44 363.58 629.37 507.31 597.09 587.08 503.65 556.52 443.53 439.58 506.63 412.52 425.36 322.92 411.44 207 444.93 207 608.44"
          />
          <path
            stroke={strokeColor900}
            strokeWidth={strokenWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={fillBG}
            d="M173.38,632.08H118.22A27.59,27.59,0,0,1,90.64,604.5V439a27.58,27.58,0,0,1,27.58-27.58h55.16A27.59,27.59,0,0,1,201,439V604.5A27.6,27.6,0,0,1,173.38,632.08Z"
          />
          <path
            stroke={strokeColor900}
            strokeWidth={strokenWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={fillBG}
            d="M366.44,521.76h64.35a55,55,0,0,0,33.09-11l66.64-50a41.79,41.79,0,0,1,54.61,3.89h0a41.77,41.77,0,0,1,0,59.08L528,580.89a110.37,110.37,0,0,1-56.37,30.17l-80.81,16.16a110.33,110.33,0,0,1-48.41-1.15l-73.08-18.26a109,109,0,0,0-26.73-3.31H201"
          />
          <path
            stroke={strokeColor900}
            strokeWidth={strokenWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={fillBG}
            d="M366.44,521.76h41A41.78,41.78,0,0,0,449.18,480v-8.35a41.74,41.74,0,0,0-31.63-40.52l-63.22-15.8a129.45,129.45,0,0,0-31.41-3.86h0a129.32,129.32,0,0,0-71.85,21.76L201,466.6"
          />
          <path
            stroke={strokeColor900}
            strokeWidth={strokenWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={fillRedBG}
            d="M528.86,150c40.44,5.87,62.39,45.39,57.56,78.55-9.76,67.27-130.37,106-132.41,105.69s-106.63-71.74-96.86-139c4.82-33.15,37.09-64.79,77.53-58.91,23.11,3.36,36.73,16.38,44.1,27.27C489,155.27,505.75,146.66,528.86,150Z"
          />
        </g>
      </svg>
    </Box>
  )

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <path
          fill={fillColor200}
          opacity="0.25"
          d="M571.92,638.77C653.34,547,839,445.33,755.76,345.47c-58-69.6-253.93-156.8-468.88-184.77C-263.25,89.13,264.27,985.52,571.92,638.77Z"
          transform="translate(-47.24 -73.83)"
        />
        <g>
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M270.84,637.38c1.83,38.34,24,74.4,61.34,91.71,49.85,23.11,110.06,3.6,137.65-44.65.18-.32.37-.64.55-1a104.21,104.21,0,0,1,30.77-33.88,64.91,64.91,0,0,0,21.27-25.68c14.61-31.5,1.53-69.27-29.22-84.55-11.91-5.92-42.2-9-65.45-10.9-15.69-1.3-27.31-6.15-35-19.92C384,492.88,355.46,477.79,333,483.2c-42.09,10.16-47.76,21.09-70,58.77-10,16.9-29,33.67-.95,59.59C269.63,608.59,270.35,627,270.84,637.38Z"
            transform="translate(-47.24 -73.83)"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M397,183.33c-13.32-34.19-45.33-60.88-86.07-66.57-54.42-7.59-105.81,26.14-117.48,77.15-.08.34-.15.68-.23,1a93.55,93.55,0,0,1-19,38.86,58.18,58.18,0,0,0-12.47,28.92c-4.38,32.39,19.48,63.06,53.35,68.67,13.12,2.18,42.86-3.14,65.57-7.62,15.32-3,27.84-1.73,39.31,8.68,13,11.83,44.79,17.84,64.49,7,37-20.43,39.07-31.83,48.88-71.87,4.41-18,17.39-38.2-17.1-54.16C406.89,209.06,400.65,192.62,397,183.33Z"
            transform="translate(-47.24 -73.83)"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M646.49,505.57c38.3-2.4,74-25.13,90.78-62.7,22.37-50.19,2-110.1-46.69-137l-1-.53a104.17,104.17,0,0,1-34.34-30.27,64.85,64.85,0,0,0-26-20.88c-31.72-14.14-69.29-.5-84.11,30.47-5.74,12-8.35,42.33-9.92,65.61-1.06,15.7-5.74,27.4-19.4,35.28-15.53,9-30.18,37.76-24.44,60.11,10.78,41.92,21.79,47.43,59.8,69.15,17,9.75,34.11,28.46,59.6.06C617.72,507.21,636.09,506.22,646.49,505.57Z"
            transform="translate(-47.24 -73.83)"
          />
        </g>
        <path
          fill={fillColor600}
          d="M121.91,631.69c6.29,12,20.08,17.35,39.9,23.61,18.25,5.76,37-1.85,39.38-4.8,10.9-13.69-30.26-44.52-42.26-43.22C145.3,608.74,113.25,615.18,121.91,631.69Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M689.12,537.16c4.81-25-23.48-22.66-33.91-15.09-12.62,9.17,12.24,41.06,25,50.88C700.65,585.18,687,548.43,689.12,537.16Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M469,645c128-53.93,271.74-260.46,189.17-421.93-49.69-97.2-265.41,28.33-382.63-12.29C171.13,174.59,19.29,834.48,469,645Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M203.15,143.57c.45-29.66,37.38,1.33,46.65,15.39s.95,26.27-13.11,35.53-45.83,13.85-55.09-.21S202.55,182.86,203.15,143.57Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M319.25,492.5v99.67h99.67V492.5"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M506.13,243.33H232a87.21,87.21,0,0,0-87.2,87.21v137a24.92,24.92,0,0,0,24.91,24.92H568.42a24.93,24.93,0,0,0,24.92-24.92v-137A87.22,87.22,0,0,0,506.13,243.33Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M219.59,343H244.5"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M418.92,168.58V343"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M418.92,93.83H543.5v74.75H418.92Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M418.89,333.66a9.34,9.34,0,1,0,9.37,9.34,9.36,9.36,0,0,0-9.37-9.34"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M232,243.33a87.21,87.21,0,0,1,87.21,87.21v162"
          transform="translate(-47.24 -73.83)"
        />
      </svg>
    </Box>
  )
}

export default memo(SocialManagerModuleBrand)
